export type UserRole = 'customer' | 'barber' | 'admin';
export type BookingStatus = 'Menunggu' | 'Proses' | 'Selesai' | 'Batal';

export interface PortfolioItem {
  id: string;
  imageUrl: string;
  title?: string;
  description?: string;
  createdAt: any;
}

export interface UserProfile {
  uid: string;
  id?: string; // Some parts use id as alias for uid
  name: string;
  email: string;
  phone?: string;
  address?: string;
  province?: string;
  city?: string;
  district?: string;
  isVerified?: boolean;
  role: UserRole;
  gender?: 'pria' | 'wanita';
  avatar?: string;
  rating?: number;
  ratingCount?: number;
  bio?: string;
  portfolio?: PortfolioItem[];
  specialties?: string[];
  price?: number;
  services?: Service[];
  status?: 'Tersedia' | 'Sibuk' | 'Non-Aktif';
  experience?: number;
  toolsCompleteness?: string;
  registeredViaForm?: boolean;
  notificationSettings?: {
    newBooking: boolean;
    statusUpdate: boolean;
    newChat: boolean;
  };
}

export interface Service {
  id: string;
  name: string;
  price: number;
  duration: number;
}

export interface Booking {
  id: string;
  customerId: string;
  barberId: string;
  serviceId: string;
  date: string;
  time: string;
  status: BookingStatus;
  totalPrice: number;
  location?: string;
  rating?: number;
  review?: string;
  createdAt: any;
  paymentMethod?: string;
  paymentProofUrl?: string;
  paymentStatus?: 'Belum Bayar' | 'Menunggu Verifikasi' | 'Lunas';
  // Join fields for UI convenience
  barberName?: string;
  serviceName?: string;
}

export interface ChatMessage {
  id: string;
  senderId: string;
  senderName: string;
  text: string;
  timestamp: any;
  bookingId: string;
  customerId: string;
  barberId: string;
  isRead?: boolean;
}

export enum OperationType {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
  LIST = 'list',
  GET = 'get',
  WRITE = 'write',
}

export interface FirestoreErrorInfo {
  error: string;
  operationType: OperationType;
  path: string | null;
  authInfo: {
    userId?: string | null;
    email?: string | null;
    emailVerified?: boolean | null;
    isAnonymous?: boolean | null;
  }
}
